import React, {Fragment} from "react";
import {EventListRequest, ListUserLabelsRequest, UserLabel } from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../ListView";
import {Form, FormListener} from "../form/Form";
import {ColumnType} from "../list/list/ColumnType";
import { ActionType } from "../list/list/DataTable";
import { FormInput } from "../form/FormInput";
import { FormGroup } from "../form/FormGroup";
import { Submit } from "../form/Submit";
import { Validators } from "../form/Validators";
import { UserLabelService } from "../../services/UserLabelService";
import { DataModal } from "../../util/DataModal";



interface State extends ListViewState<ListUserLabelsRequest> {
    listRequest? : ListUserLabelsRequest;
    form? : ListUserLabelsRequest;
    validationMap? : any;
    lookupExpanded?: boolean;
    hasError: boolean;
}

export class UserLabelListView extends ListView<State, ListUserLabelsRequest> implements FormListener<ListUserLabelsRequest>{

    columns = [
        { property : "id", name : "ID"},
        { property : "value", name : "Tag"},
        { property : "createdBy", name : "Created By"},
        { property : "timestamp", name : "Timestamp", type : ColumnType.DATE},
        { property : "enabled", name : "Enabled",  renderer: (property: string, name: string, item: ListUserLabelsRequest) => {
            if(item.enabled){
                return <div className={"form-check"}><input className={"form-check-input"} type="checkbox" checked={true}/></div>;
            }else{
                return <div className={"form-check"}><input className={"form-check-input"} type="checkbox" checked={false}/></div>;
            }
        }},
    ];

    actions = [
        { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/user-label/" + item.id },
        { id : "delete", name : "Delete", className : "btn btn-danger", iconClassName : "fa fa-times", type : ActionType.CONFIRMATION }
    ];
    service : UserLabelService;

    initialState : ListUserLabelsRequest = {
        limit: 20,
        orderBy: "id",
        startDate:undefined,
        endDate:undefined,
        ascending: false,
        id: undefined,
        value: undefined,
        description: undefined,
        enabled: undefined
    }

    
    constructor(props : ListViewProps){
        super(props, "/user-labels/list");
        this.service = getContainer().getUserLabelService();

        if (this.state.listRequest){
            this.state = createInitialState( this.initialState, this.state = {lookupExpanded:false, ...this.state});
        }
    }
    onSubmit(): void {
        let listRequest : ListUserLabelsRequest = Object.assign({},this.state.form);
        listRequest.offset = 0;
        
        this.updateListState(listRequest)
    };

    onSubmitError() :  void {
        console.log("submit error!")
    }

    formDidUpdate(formModel: ListUserLabelsRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : UserLabel, action : string) : Promise<any> | undefined {
        if(action === "delete") {
            return this.service.remove(""+item.id).catch((e)=>{
                this.setState({hasError:true})
                throw e
            });
        }
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.updateListState(listRequest);
        }
    }
    getTitle() {
        return "List User Tags"
    }

    preset(preset: "day" | "week" | "month") {

        let filter: EventListRequest|undefined = this.state.listRequest;
        let today = new Date(new Date().setDate(new Date().getDate())).toISOString().slice(0,10);
        let yesterday = new Date(new Date().setDate(new Date().getDate()-1)).toISOString().slice(0,10);
        let sevenDaysAgo = new Date(new Date().setDate(new Date().getDate()-7)).toISOString().slice(0,10);
        let thirtyDaysAgo = new Date(new Date().setDate(new Date().getDate()-30)).toISOString().slice(0,10);

        switch(preset) {
            case "day":
                filter = {...this.state.form, startDate: yesterday as any, endDate: today as any};
                break;

            case "week":
                filter = {...this.state.form, startDate: sevenDaysAgo as any, endDate: today as any};
                break;

            case "month":
                filter = {...this.state.form, startDate: thirtyDaysAgo as any, endDate: today as any};
                break;
        }
        this.setState({form:filter})
    }

    getSearchByUserId() {
        return(
            <div className="row">
                <div className={"col-lg-6"}>
                    <div className="card-box">
                        <h4>Find By Id</h4>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"} model="id">
                                <FormInput model={"id"} className={"form-control"} validators={[Validators.number()]}/>
                                <span className={"help-text"}>Finds labels by id. Exact match only.</span>
                            </FormGroup>
                            <Submit className={"btn btn-primary"}>Search</Submit>
                        </Form>
                    </div>

                </div>
            </div>
        )
    }

    getSearchByFilter() {

        return(
            <div className="card-box expandable-box" style={!this.state.lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !this.state.lookupExpanded ? this.setState({lookupExpanded:true}) : null}>
                {this.state.lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); this.setState({lookupExpanded : false});}}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); this.setState({lookupExpanded : true});}}><i className="mdi mdi-plus"></i></a>
                )}

                <h4 className="header-title mb-3" onClick={()=>this.setState({lookupExpanded : !this.state.lookupExpanded})}>Advanced Search</h4>
                {this.state.lookupExpanded && (
                    <div>
                        <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <FormGroup className="form-group">
                                        <label>Timestamp</label>
                                        <h5>Presets</h5>
                                        <div>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("day")}>Day</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("week")}>Week</span>
                                            <span className="btn btn-sm btn-primary" style={{marginRight:'10px'}} onClick={() => this.preset("month")}>Month</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className={"form-group"}>
                                        <label htmlFor={"startDate"}>From:</label>
                                        <FormInput model={"startDate"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                        <label htmlFor={"endDate"}>To:</label>
                                        <FormInput model={"endDate"} className={"form-control col-lg-6"} type={"date"} onFocus={() => this.clearForAdvanced()} />
                                        <span className={"help-text"}>To but not included</span>
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="form-group">
                                    <Submit className={"btn btn-primary"}>Search</Submit>
                                    <button onClick={() => this.clearFilter()} className={"btn btn-secondary"}>Clear</button>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        )
    }

    clearForAdvanced() {
        this.setState({form: {...this.state.form, id:undefined}})

    }

    clearFilter() {
        this.setState({form: this.initialState})
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                {this.getSearchByUserId()}
                {this.getSearchByFilter()}
                <EntityDataTable 
                    service={this.service}
                    onPagerChange={this.pagerChanged.bind(this)}
                    columns={this.columns}
                    listRequest={this.state.listRequest}
                    onAction={this.onAction.bind(this)}
                    actions={this.actions}/>
                <DataModal show={this.state.hasError} onClose={()=>{this.setState({hasError:false})}}
                heading="Error" data={"Update failed. Please make sure label is not in use"}/>
            </Fragment>
        );
    }
}

export default withRouter(UserLabelListView)